import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { lawFirmBreadcrumbsHistory } from './functions';

const LawFirmBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="law-firm-breadcrumbs"
      history={lawFirmBreadcrumbsHistory(t, location)}
    />
  );
};

export default LawFirmBreadcrumbs;
